__turbopack_context__.v({
  "accent": "PariV2-module__YK3pFG__accent",
  "cardLead": "PariV2-module__YK3pFG__cardLead",
  "cardTitle": "PariV2-module__YK3pFG__cardTitle",
  "ctaLink": "PariV2-module__YK3pFG__ctaLink",
  "ctaRow": "PariV2-module__YK3pFG__ctaRow",
  "eyebrow": "PariV2-module__YK3pFG__eyebrow",
  "inlineLink": "PariV2-module__YK3pFG__inlineLink",
  "methodBody": "PariV2-module__YK3pFG__methodBody",
  "methodTitle": "PariV2-module__YK3pFG__methodTitle",
  "pillarBody": "PariV2-module__YK3pFG__pillarBody",
  "pillarIcon": "PariV2-module__YK3pFG__pillarIcon",
  "pillarTitle": "PariV2-module__YK3pFG__pillarTitle",
  "studentCard": "PariV2-module__YK3pFG__studentCard",
  "trustItem": "PariV2-module__YK3pFG__trustItem",
  "trustRow": "PariV2-module__YK3pFG__trustRow",
});
